import clsx from 'clsx'
import { Button, Typography } from 'gu-ui-kit'
import formStyles from 'modules/Forms/common-form.module.scss'
import PropTypes from 'prop-types'
import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { formValueSelector, reduxForm } from 'redux-form'
import validator from 'utils/asyncValidator'
import shouldAsyncValidate from 'utils/shouldAsyncValidate'
import advertiserInfoValidationRulesExtended
  from 'modules/Forms/Account/Create/subcomponents/advertiser-info-validation-rules-extended'
import AdvertiserFieldsExtended from 'modules/Forms/Account/Create/subcomponents/advertiserFieldsExtended'
import { CREATE_USER } from 'modules/Advertisers/Create/types'
import PageHeader from 'components/PageHeader'

let AdvertiserCreate = ({ handleSubmit, submitting, onClose = () => {}, form, advertiserId }) => {
  const { t } = useTranslation()
  const selector = formValueSelector(form)
  const { advertiser_info } = useSelector((state) => ({
    advertiser_info: selector(state, 'advertiser_info'),
  }))

  const submit = useCallback(
    (values, dispatch) =>
      new Promise((resolve, reject) => {
        dispatch({
          meta: { resolve, reject },
          type: CREATE_USER,
          payload: {
            id: advertiserId,
            data: { ...values.advertiser_info },
            formName: form,
          },
        })
      }).then(onClose),
    [onClose, advertiserId, form],
  )

  return (
    <div className={formStyles['formContainer']}>
      <div className={formStyles['formContainer__inner']}>
        <form
          onSubmit={handleSubmit(submit)}
          className={'margin-top-16'}
        >
          <PageHeader className={'margin-bottom-8'}>
            {t('advertisers::form.header', {
              context: advertiserId ? 'edit' : 'new',
            })}
          </PageHeader>
          <Typography
            variant={'Body-20'}
            color={'Label-Secondary'}
            noMargin
          >
            {t('advertisers::form.summary')}
          </Typography>

          <AdvertiserFieldsExtended
            advertiser_info={advertiser_info}
            showContractTypeOtherOption={false}
          />

          <div
            className={clsx(
              formStyles['formControl__action-buttons'],
              formStyles['row_with-tooltip'],
            )}
          >
            <Button
              disabled={submitting}
              onClick={onClose}
              variant="ghost"
              grey
              size="l"
              type="button"
            >
              {t('common::form_buttons.cancel')}
            </Button>
            <Button
              disabled={submitting}
              size="l"
              variant="primary"
              type="submit"
            >
              {t(`common::form_buttons.${advertiserId ? 'save' : 'create'}`)}
            </Button>
          </div>
        </form>
      </div>
    </div>
  )
}

AdvertiserCreate = reduxForm({
  form: 'AdvertiserCreate',
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  forceUnregisterOnUnmount: true,
  shouldAsyncValidate: shouldAsyncValidate,
  asyncValidate: validator(advertiserInfoValidationRulesExtended().pick(['advertiser_info'])),
  initialValues: {
    advertiser_info: {
      type: '',
      tax_number: '',
      phone: '',
      name: '',
      contract: {
        number: '',
        date: '',
        type: '',
        amount: null,
        subject_type: '',
        action_type: '',
      },
      counterparty: {
        type: '',
        name: '',
        tax_number: '',
        phone: '',
      },
    },
  },
})(AdvertiserCreate)

AdvertiserCreate.propTypes = {
  handleSubmit: PropTypes.func,
  submitting: PropTypes.bool,
  onClose: PropTypes.func,
  form: PropTypes.string,
  anyTouched: PropTypes.bool,
  advertiserId: PropTypes.string,
}

export default AdvertiserCreate
